<template>
	<v-list class="pt-0" style="max-height: 300px;overflow: scroll;">
		<draggable
			v-model="prefixesFiltered"
			handle=".handle_drag"
			@end="startEndDragPrefixEvent">
			<v-list-item
				v-for="(item, i) in prefixesFiltered"
				:key="i"
				class="px-0 py-0"
			>
				<div style="width: 100%">
					<div class="d-flex flex-row px-2 pt-2 justify-space-between">
						<div class="d-flex flex-row align-center caption">
							<v-icon class="handle_drag mr-2">mdi-unfold-more-horizontal</v-icon>
							<p class="mb-0 caption font-weight-bold" style="color: #707070;">{{ item.name }}</p>
						</div>
						<div>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										icon
										dark
										x-small
										color="warning"
										@click="setBudgetPrefix(item)"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon small dark>mdi-pencil</v-icon>
									</v-btn>
								</template>
								<span>Editar Prefijo</span>
							</v-tooltip>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										icon
										dark
										x-small
										color="error"
										@click="deleteBugdetPrefix(item)"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon small dark>mdi-delete-outline</v-icon>
									</v-btn>
								</template>
								<span>Eliminar Prefijo</span>
							</v-tooltip>
						</div>
					</div>
				</div>
			</v-list-item>
		</draggable>
	</v-list>
</template>

<script>
import _debounce from 'lodash/debounce'
import draggable from 'vuedraggable'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import {removeBudgetPrefix, updateOrderPrefix} from '@/helpers/api/budgets'

export default {
	name: 'PrefixListingMenu',
	components: {draggable},
	props: {
		type: {
			type: String,
			default: 'budget'
		}
	},
	computed: {
		prefixes(){
			return this.$store.state.budget.companiesBudgetPrefixes
		},
		prefixesFiltered: {
			get() {
				return this.prefixes.filter(prefix => prefix.type === this.type && prefix.company_id)
			},
			set(newReports) {
				const updated = [
					...this.prefixes.filter(p => p.type !== this.type),
					...newReports
				]
				this.$store.commit('budget/setCompaniesBudgetPrefixes', updated)
			}
		}
	},
	methods: {
		startEndDragPrefixEvent: _debounce(function(){ this.endDragPrefixEvent() }, 500),
		async endDragPrefixEvent(){
			const prefixes = this.prefixesFiltered.map((prefix, index) => {
				return {id: prefix.id, order: index + 1}
			})
			await updateOrderPrefix({prefixes})
			this.$store.dispatch('budget/getBudgetPrefixes')
			eventBus.$emit('reloadInformation')
		},
		setBudgetPrefix(prefix = null){
			let newPrefix = {type: this.type}
			if(prefix){
				newPrefix = {
					...newPrefix,
					...prefix,
					...{budget_prefix_id: prefix.id}
				}
			}
			this.$store.commit('budget/setNewBudgetPrefixModalEditing', newPrefix)
      this.$store.commit('budget/setNewBudgetPrefixModal', true)
		},
		async deleteBugdetPrefix(prefix){
			await removeBudgetPrefix({budget_prefix_id: prefix.id})
			this.$store.dispatch('budget/getBudgetPrefixes')
		}
	}
}
</script>